import React from 'react';
import '../TopLandingNav/TopLandingNavStyle.scss';
import PhoneInTalkOutlinedIcon from '@mui/icons-material/PhoneInTalkOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import facebook from '../../assets/images/facebook.png';
import whatsapp from '../../assets/images/whatsapp.png';
import instagram from '../../assets/images/instagram.png';
import twitter from '../../assets/images/twitter.png';
import youtube from '../../assets/images/youtube.png';
import dhofarNewLogo from '../../assets/images/dhofar-insurance-logo.svg';
import HoverDropdown from '../HoverDropDown/HoverDropDown';

export default function TopLandingNav() {
  return (
    <>
      <div className='grey-container d-none d-md-flex'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-7 d-none d-md-flex align-items-center'>
              <div class='d-flex justify-content-start align-items-start'>
                <label className='label-font d-flex align-items-start gap-2 text-decoration-none email-link'>
                  <span className='icon-color'>
                    <PhoneInTalkOutlinedIcon sx={{ fontSize: 20 }} />
                  </span>
                  <span className='email-text'>Toll Free 8000 77 77</span>
                </label>
                <a
                  href='https://dhofarinsurance.com/contact-us/'
                  rel='noopener noreferrer'
                  className='label-font d-flex align-items-start gap-2 text-decoration-none email-link'
                >
                  <span className='icon-color'>
                    <EmailOutlinedIcon sx={{ fontSize: 20 }} />
                  </span>
                  <span className='email-text'>dhofar@dhofarinsurance.com</span>
                </a>
                <a
                  href='https://dhofarinsurance.com/employee/'
                  rel='noopener noreferrer'
                  className='label-font d-flex align-items-start gap-2 text-decoration-none email-link'
                >
                  <span className='icon-color'>
                    <PersonOutlineOutlinedIcon sx={{ fontSize: 20 }} />
                  </span>
                  <span className='email-text'>Employee Login</span>
                </a>
              </div>
            </div>
            <div className='col-md-5  d-none d-md-flex justify-content-end'>
              <div class='d-flex justify-content-end align-items-start'>
                <a
                  href='https://wa.me/+96871998000'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='d-flex align-items-start text-decoration-none email-link social-media-icon'
                >
                  <img
                    src={whatsapp}
                    alt='whatsapp'
                    style={{ height: '36px', width: '36px' }}
                  />
                </a>
                <a
                  href='https://www.facebook.com/DhofarInsurance'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='d-flex align-items-start  text-decoration-none email-link social-media-icon'
                >
                  <img
                    src={facebook}
                    alt='facebook'
                    style={{ height: '36px', width: '36px' }}
                  />
                </a>
                <a
                  href='https://www.instagram.com/dhofarinsurance/'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='d-flex align-items-start  text-decoration-none email-link social-media-icon'
                >
                  <img
                    src={instagram}
                    alt='instagram'
                    style={{ height: '36px', width: '36px' }}
                  />
                </a>
                <a
                  href='https://twitter.com/InsuranceDhofar'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='d-flex align-items-start  text-decoration-none email-link social-media-icon'
                >
                  <img
                    src={twitter}
                    alt='twitter'
                    style={{ height: '36px', width: '36px' }}
                  />
                </a>
                <a
                  href='https://www.youtube.com/channel/UCpt4ZDQY-SHfGQdz_QVOn1g?view_as=subscriber'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='d-flex align-items-start  text-decoration-none email-link social-media-icon'
                >
                  <img
                    src={youtube}
                    alt='youtube'
                    style={{ height: '36px', width: '36px' }}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='bg-white white-drawer-padding'>
        <div className='container'>
          <div className='row align-items-center'>
            {/* Logo: Always visible */}
            <div className='col-6 col-md-3 d-flex align-items-center'>
              <img
                src={dhofarNewLogo}
                alt='dhofarNewLogo'
                style={{ width: '220px' }}
              />
            </div>

            {/* ===== MOBILE NAV (offcanvas) ===== */}
            <div className='col-6 col-md-9 d-flex justify-content-end d-block d-lg-none'>
              <button
                className='navbar-toggler ms-auto'
                type='button'
                data-bs-toggle='offcanvas'
                data-bs-target='#mobileOffcanvas'
                aria-controls='mobileOffcanvas'
              >
                <span className='navbar-toggler-icon fs-4'><i class="bi bi-list"></i></span>
              </button>

              {/* Offcanvas Sidebar */}
              <div
                className='offcanvas offcanvas-end'
                tabIndex='-1'
                id='mobileOffcanvas'
                aria-labelledby='mobileOffcanvasLabel'
              >
                <div className='offcanvas-header'>
                  <button
                    type='button'
                    className='btn-close'
                    data-bs-dismiss='offcanvas'
                    aria-label='Close'
                  ></button>
                </div>
                <div className='offcanvas-body'>
                  <div className='col-12 align-items-center'>
                    <div class='justify-content-start align-items-start'>
                      <label className='col-12 label-font d-flex align-items-start gap-2 text-decoration-none email-link'>
                        <span className='icon-color'>
                          <PhoneInTalkOutlinedIcon sx={{ fontSize: 20 }} />
                        </span>
                        <span className='email-text'>Toll Free 8000 77 77</span>
                      </label>
                      <a
                        href='https://dhofarinsurance.com/contact-us/'
                        rel='noopener noreferrer'
                        className='col-12 mt-3 label-font d-flex align-items-start gap-2 text-decoration-none email-link'
                      >
                        <span className='icon-color'>
                          <EmailOutlinedIcon sx={{ fontSize: 20 }} />
                        </span>
                        <span className='email-text'>dhofar@dhofarinsurance.com</span>
                      </a>
                    </div>
                  </div>
                  <ul className='navbar-nav mt-3'>
                    {/* Use your custom component or plain <li>s */}
                    <HoverDropdown
                      title='ABOUT US'
                      items={[
                        {
                          label: 'Company Profile',
                          link: 'https://dhofarinsurance.com/company-profile/',
                          active: true,
                        },
                        {
                          label: 'Board of Directors',
                          link: 'https://dhofarinsurance.com/board-of-directors/',
                        },
                        {
                          label: 'Management Team',
                          link: 'https://dhofarinsurance.com/management-team/',
                        },
                        {
                          label: 'Vision Mission Values',
                          link: 'https://dhofarinsurance.com/vision-mission-values/',
                        },
                        {
                          label: 'Investor Relations',
                          link: 'https://dhofarinsurance.com/investor-relations/',
                        },
                        {
                          label: 'Quarterly and Annual Reports',
                          link: 'https://dhofarinsurance.com/quarterly-and-annual-reports/',
                        },
                      ]}
                    />
                    <HoverDropdown
                      title='PRODUCTS'
                      columns={2}
                      items={[
                        {
                          label: 'Motor Insurance',
                          link: 'https://dhofarinsurance.com/motor-insurance/',
                        },
                        {
                          label: 'Life Insurance',
                          link: 'https://dhofarinsurance.com/life-insurance/',
                        },
                        {
                          label: 'Medical Insurance',
                          link: 'https://dhofarinsurance.com/medical-insurance/',
                        },
                        {
                          label: 'Travel Insurance',
                          link: 'https://dhofarinsurance.com/travel-insurance/',
                        },
                        {
                          label: 'Home Contents Insurance',
                          link: 'https://dhofarinsurance.com/home-contents-insurance/',
                        },
                        {
                          label: 'Property Insurance',
                          link: 'https://dhofarinsurance.com/property-insurance/',
                        },
                        {
                          label: 'Liability Insurance',
                          link: 'https://dhofarinsurance.com/liability-insurance/',
                        },
                        {
                          label: 'Marine Insurance',
                          link: 'https://dhofarinsurance.com/marine-insurance/',
                        },
                        {
                          label: 'Cyber Insurance',
                          link: 'https://dhofarinsurance.com/cyber-insurance/',
                        },
                        {
                          label: 'Energy Insurance',
                          link: 'https://dhofarinsurance.com/energy-insurance/',
                        },
                        {
                          label: 'Industrial Insurance',
                          link: 'https://dhofarinsurance.com/industrial-insurance/',
                        },
                        {
                          label: 'Engineering Insurance',
                          link: 'https://dhofarinsurance.com/engineering-insurance/',
                        },
                        {
                          label: 'Oil and Petrochemical Insurance',
                          link: 'https://dhofarinsurance.com/oil-petrochemical-insurance/',
                        },
                        {
                          label: 'Personal Accident Insurance',
                          link: 'https://dhofarinsurance.com/personal-accident-insurance/',
                        },
                        {
                          label: 'Workmen’s Compensation Insurance',
                          link: 'https://dhofarinsurance.com/workmen-compensation-insurance/',
                        },
                      ]}
                    />

                    <HoverDropdown
                      title='INVESTOR RELATIONS'
                      items={[
                        {
                          label: 'Share Information',
                          link: 'https://tools.euroland.com/tools/custom/om-dics/bundle.html?lang=en-gb',
                          target: '_blank',
                          active: true,
                        },
                        {
                          label: 'Financial Information',
                          link: 'https://tools.euroland.com/factsheet/om-dics/factsheethtml.asp?lang=english',
                          target: '_blank',
                        },
                        {
                          label: 'Announcements',
                          link: 'https://tools.eurolandir.com/tools/pressreleases/?companycode=om-dics&amp;lang=en-gb',
                          target: '_blank',
                        },
                        {
                          label: 'Dividends',
                          link: 'https://tools.eurolandir.com/tools/tsr/iframe/?companycode=om-dics&amp;lang=en-gb',
                          target: '_blank',
                        },
                      ]}
                    />
                    <li className='nav-item nav-li-padding'>
                      <a
                        className='nav-link'
                        href='https://dhofarinsurance.com/buy-online/'
                      >
                        BUY ONLINE
                      </a>
                    </li>
                    <li className='nav-item nav-li-padding'>
                      <a
                        className='nav-link'
                        href='https://dhofarinsurance.com/branch-networks/'
                      >
                        BRANCH NETWORK
                      </a>
                    </li>
                    <li className='nav-item nav-li-padding'>
                      <a
                        className='nav-link'
                        href='https://dhofarinsurance.com/contact-us/'
                      >
                        CONTACT US
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* ===== DESKTOP NAVBAR (standard horizontal) ===== */}
            <div className='col-md-9 justify-content-end d-none d-lg-flex'>
              <nav className='navbar navbar-expand-lg custom-navbar w-100'>
                <ul className='navbar-nav align-items-center ms-auto'>
                  <HoverDropdown
                    title='ABOUT US'
                    items={[
                      {
                        label: 'Company Profile',
                        link: 'https://dhofarinsurance.com/company-profile/',
                        active: true,
                      },
                      {
                        label: 'Board of Directors',
                        link: 'https://dhofarinsurance.com/board-of-directors/',
                      },
                      {
                        label: 'Management Team',
                        link: 'https://dhofarinsurance.com/management-team/',
                      },
                      {
                        label: 'Vision Mission Values',
                        link: 'https://dhofarinsurance.com/vision-mission-values/',
                      },
                      {
                        label: 'Investor Relations',
                        link: 'https://dhofarinsurance.com/investor-relations/',
                      },
                      {
                        label: 'Quarterly and Annual Reports',
                        link: 'https://dhofarinsurance.com/quarterly-and-annual-reports/',
                      },
                    ]}
                  />
                  <HoverDropdown
                    title='PRODUCTS'
                    columns={2}
                    items={[
                      {
                        label: 'Motor Insurance',
                        link: 'https://dhofarinsurance.com/motor-insurance/',
                      },
                      {
                        label: 'Life Insurance',
                        link: 'https://dhofarinsurance.com/life-insurance/',
                      },
                      {
                        label: 'Medical Insurance',
                        link: 'https://dhofarinsurance.com/medical-insurance/',
                      },
                      {
                        label: 'Travel Insurance',
                        link: 'https://dhofarinsurance.com/travel-insurance/',
                      },
                      {
                        label: 'Home Contents Insurance',
                        link: 'https://dhofarinsurance.com/home-contents-insurance/',
                      },
                      {
                        label: 'Property Insurance',
                        link: 'https://dhofarinsurance.com/property-insurance/',
                      },
                      {
                        label: 'Liability Insurance',
                        link: 'https://dhofarinsurance.com/liability-insurance/',
                      },
                      {
                        label: 'Marine Insurance',
                        link: 'https://dhofarinsurance.com/marine-insurance/',
                      },
                      {
                        label: 'Cyber Insurance',
                        link: 'https://dhofarinsurance.com/cyber-insurance/',
                      },
                      {
                        label: 'Energy Insurance',
                        link: 'https://dhofarinsurance.com/energy-insurance/',
                      },
                      {
                        label: 'Industrial Insurance',
                        link: 'https://dhofarinsurance.com/industrial-insurance/',
                      },
                      {
                        label: 'Engineering Insurance',
                        link: 'https://dhofarinsurance.com/engineering-insurance/',
                      },
                      {
                        label: 'Oil and Petrochemical Insurance',
                        link: 'https://dhofarinsurance.com/oil-petrochemical-insurance/',
                      },
                      {
                        label: 'Personal Accident Insurance',
                        link: 'https://dhofarinsurance.com/personal-accident-insurance/',
                      },
                      {
                        label: 'Workmen’s Compensation Insurance',
                        link: 'https://dhofarinsurance.com/workmen-compensation-insurance/',
                      },
                    ]}
                  />

                  <HoverDropdown
                    title='INVESTOR RELATIONS'
                    items={[
                      {
                        label: 'Share Information',
                        link: 'https://tools.euroland.com/tools/custom/om-dics/bundle.html?lang=en-gb',
                        target: '_blank',
                        active: true,
                      },
                      {
                        label: 'Financial Information',
                        link: 'https://tools.euroland.com/factsheet/om-dics/factsheethtml.asp?lang=english',
                        target: '_blank',
                      },
                      {
                        label: 'Announcements',
                        link: 'https://tools.eurolandir.com/tools/pressreleases/?companycode=om-dics&amp;lang=en-gb',
                        target: '_blank',
                      },
                      {
                        label: 'Dividends',
                        link: 'https://tools.eurolandir.com/tools/tsr/iframe/?companycode=om-dics&amp;lang=en-gb',
                        target: '_blank',
                      },
                    ]}
                  />
                  <li className='nav-item nav-li-padding'>
                    <a
                      className='nav-link'
                      href='https://dhofarinsurance.com/buy-online/'
                    >
                      BUY ONLINE
                    </a>
                  </li>
                  <li className='nav-item nav-li-padding'>
                    <a
                      className='nav-link'
                      href='https://dhofarinsurance.com/branch-networks/'
                    >
                      BRANCH NETWORK
                    </a>
                  </li>
                  <li className='nav-item nav-li-padding'>
                    <a
                      className='nav-link'
                      href='https://dhofarinsurance.com/contact-us/'
                    >
                      CONTACT US
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
